export function convert(str, delimiter="-") {
    // Handle null, undefined, or empty string
    if (!str || str === null || str === undefined || str === "") {
      return "N/A";
    }
    // Remove ordinal suffixes from the day part of the string (e.g., "8th" -> "8")
    const cleanedStr = str.replace(/(\d+)(st|nd|rd|th)/g, '$1');
    var date = new Date(cleanedStr),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join(delimiter);
  }
  export function convertReversed(str, delimiter="/") {
  // Handle null, undefined, or empty string
  if (!str || str === null || str === undefined || str === "") {
    return "N/A";
  }
  var date = new Date(str),
    mnth = ("0" + (date.getMonth() + 1)).slice(-2),
    day = ("0" + date.getDate()).slice(-2);
  return [mnth, day, date.getFullYear()].join(delimiter);
  }
  export function today() {
  var date = new Date(),
  mnth = ("0" + (date.getMonth() + 1)).slice(-2),
  day = ("0" + date.getDate()).slice(-2);
  return [date.getFullYear(), mnth, day].join('-');
  }
  
  export function currentTime() {
  var date = new Date(),
  hours = ("0" + (date.getHours())).slice(-2),
  minutes = ("0" + (date.getMinutes())).slice(-2)
  return [hours, minutes].join(':')
  }
  export   function DisplayCurrentTime(str) {
    // Handle null, undefined, or empty string
    if (!str || str === null || str === undefined || str === "") {
      return "N/A";
    }
    var date = new Date(str);
    var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
    var am_pm = date.getHours() >= 12 ? "PM" : "AM";
    hours = hours < 10 ? "0" + hours : hours;
    var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
    var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
   var time = hours + ":" + minutes + ":" + seconds + " " + am_pm;
  //   var hours = date.getHours() < 10 ? "0" + date.getHours() : date.getHours();
  //   var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
  //   var seconds = date.getSeconds() < 10 ? "0" + date.getSeconds() : date.getSeconds();
  //  var time = hours + ":" + minutes + ":" + seconds;
    return time;   
};
export   function DisplayTime(str) {
  // Handle null, undefined, or empty string
  if (!str || str === null || str === undefined || str === "") {
    return "N/A";
  }
  var date = new Date(str);
  var hours = date.getHours() > 12 ? date.getHours() - 12 : date.getHours();
  var am_pm = date.getHours() >= 12 ? "PM" : "AM";
  hours = hours < 10 ? "0" + hours : hours;
  var minutes = date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();
 var time = hours + ":" + minutes +  " " + am_pm;

  return time;   
};
export function isToday(dateParameter) {
  var today = new Date();
  return dateParameter.getDate() === today.getDate() && dateParameter.getMonth() === today.getMonth() && dateParameter.getFullYear() === today.getFullYear();
}
 export function formatDate(string){
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(string).toLocaleDateString([],options);
}

export function formatDateForDisplay(string){
  if(!string) return "Not Set";
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(string).toLocaleDateString([],options);
}
export function validateDate(string){
  if (string === null || string === "" || string === undefined) {
    return "N/A";
  }
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    return new Date(string).toLocaleDateString([],options);
}
export function camelCase(str) {
  return str
      .replace(/\s(.)/g, function(a) {
          return a.toUpperCase();
      })
      .replace(/\s/g, '')
      .replace(/^(.)/, function(b) {
          return b.toLowerCase();
      });
}
export function capitalLetter(str) {
  return str
      .replace(/\s(.)/g, function(a) {
          return a.toLowerCase();
      })
      .replace(/\s/g, '')
      .replace(/^(.)/, function(b) {
          return b.toUpperCase();
      });
}
export function pascalCASE(str){
 return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  
}